import React from "react";
import css from './Pagination.module.css';
import classNames from "classnames";

function PaginationNumber({
  page,     
  onRefine,
  isActive,
  position, 
}) {
  if (position === 'middle') {
    return <div className={css.middle}>{page}</div>;
  }

  return (
    <button
      disabled={isActive}
      className={classNames(css.pageNumber, { [css.active]: isActive })}
      onClick={() => onRefine(page - 1)}
    >
      {page}
    </button>
  );
}

export default PaginationNumber;
